import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ServiceRespone } from 'src/app/model/serviceResponse';
import { msConfig } from 'src/app/services/ms-config';
import { AppConstants } from 'src/environments/constants';
import { IDocumentiService } from './IDocumentiService';
import { catchError, map } from 'rxjs/operators';
import { Documento, TipologiaDocumento, } from 'src/app/model/documenti/Documento';
import { Observable } from 'rxjs';
import { CommonUtils } from 'src/utils/CommonUtils';
import { fmt } from 'simple-fmt';
import { StatoSvincolo } from 'src/app/model/svincoli/Svincolo';
import { DOCUMENTI } from 'src/app/pages/documents/model/DocumentiMock';
import { FaseStandard } from 'src/app/model/ordini/PosizioneFasi';
import { ListOrdinePosizioneFasiModel } from 'src/app/pages/documents/model/ListOrdinePosizioneFasiModel';
import { ListaNCModel } from 'src/app/pages/documents/model/ListaNCModel';


@Injectable({
  providedIn: 'root'
})
export class DocumentiService implements IDocumentiService {

  constructor(private http: HttpClient) {
    console.log('dentro doc serv');
  }

  getTotaleDocumenti(isTeamView: boolean, nomeDocumento?: string, numeroOrdine?: string, tipoDoc?: TipologiaDocumento, getEliminati?: boolean, dataCaricamentoInizio?: Date, dataCaricamentoFine?: Date, codicePosizione?: string, fase?: FaseStandard, ruolo?: string): Observable<ServiceRespone> {
    let url = msConfig['ms-documenti'] + AppConstants.PATH_TOTALE_DOCUMENTI;
    let params: any = {};
    params.isTeamView = isTeamView
    params = CommonUtils.containsParam(params, nomeDocumento?.trim(), "nomeDocumento")
    params = CommonUtils.containsParam(params, numeroOrdine?.trim(), "numeroOrdine")
    params = CommonUtils.containsParam(params, tipoDoc, "tipoDoc")
    params = CommonUtils.containsParam(params, getEliminati, "getEliminati")
    params = CommonUtils.containsParam(params, fase, "fase")
    params = CommonUtils.containsParam(params, codicePosizione?.trim(), "codicePosizione")
    params = CommonUtils.containsParam(params, ruolo, "ruolo")
    if (dataCaricamentoInizio != null) {
      params = CommonUtils.containsParam(params, CommonUtils.formatDate(dataCaricamentoInizio), "dataCaricamentoInizio")
    }
    if (dataCaricamentoFine != null) {
      params = CommonUtils.containsParam(params, CommonUtils.formatDate(dataCaricamentoFine), "dataCaricamentoFine")
    }
    return this.http
      .get(url, { params })
      .pipe(map((resp: ServiceRespone) => {
        let ordini;
        ordini = resp;
        return ordini;
      }), catchError(CommonUtils.errorHandler))

  }

  getDocumenti(isTeamView: boolean, first: number, length: number, nomeDocumento?: string, numeroOrdine?: string, tipoDoc?: TipologiaDocumento, getEliminati?: boolean, dataCaricamentoInizio?: Date, dataCaricamentoFine?: Date, codicePosizione?: string, fase?: FaseStandard, ruolo?: string, ordinamento?: string, direzione?: boolean): Observable<ServiceRespone> {
    let url = msConfig['ms-documenti'] + AppConstants.PATH_DOCUMENTI;
    let params: any = {};
    params.isTeamView = isTeamView
    params.first = first
    params.length = length
    params = CommonUtils.containsParam(params, nomeDocumento?.trim(), "nomeDocumento")
    params = CommonUtils.containsParam(params, numeroOrdine?.trim(), "numeroOrdine")
    params = CommonUtils.containsParam(params, tipoDoc, "tipoDoc")
    params = CommonUtils.containsParam(params, getEliminati, "getEliminati")
    params = CommonUtils.containsParam(params, fase, "fase")
    params = CommonUtils.containsParam(params, codicePosizione?.trim(), "codicePosizione")
    params = CommonUtils.containsParam(params, ruolo, "ruolo")
    params = CommonUtils.containsParam(params, ordinamento?.trim(), "ordinamento")
    params = CommonUtils.containsParam(params, direzione, "direzione")
    if (dataCaricamentoInizio != null) {
      params = CommonUtils.containsParam(params, CommonUtils.formatDate(dataCaricamentoInizio), "dataCaricamentoInizio")
    }
    if (dataCaricamentoFine != null) {
      params = CommonUtils.containsParam(params, CommonUtils.formatDate(dataCaricamentoFine), "dataCaricamentoFine")
    }
    return this.http
      .get(url, { params })
      .pipe(map((resp: ServiceRespone) => {
        let ordini;
        ordini = resp;
        return ordini;
      }))
  }

  getListaDocumentiPerNC(isTeamView: boolean, first: number, length: number, idNonConformita: number, getEliminati?: boolean, ruolo?: string, ordinamento?: string, direzione?: boolean): Observable<ServiceRespone> {
    let url = msConfig['ms-documenti'] + AppConstants.PATH_DOCUMENTI_PER_NC;
    let params: any = {};
    params.isTeamView = isTeamView
    params.first = first
    params.length = length
    params.idNonConformita = idNonConformita
    params = CommonUtils.containsParam(params, getEliminati, "getEliminati")
    params = CommonUtils.containsParam(params, ruolo, "ruolo")
    params = CommonUtils.containsParam(params, ordinamento?.trim(), "ordinamento")
    params = CommonUtils.containsParam(params, direzione, "direzione")

    return this.http
      .get(url, { params })
      .pipe(map((resp: ServiceRespone) => {
        let ordini;
        ordini = resp;
        return ordini;
      }))
  }

  //MESSO SOLO PER DEMO SPRINT 4 e 5 : DA RIMUOVERE
  uploadDocumentoFasi(idOrdine: Number, idFase: Number) {
    let url = msConfig['ms-documenti'] + AppConstants.PATH_DOCUMENTI;
    let params: any = {};
    params.tipoDoc = TipologiaDocumento.FINAL_DATA;
    params.idOrdine = idOrdine;
    params.idFasiList = idFase;
    return this.http
      .post(url, null, { params })
      .pipe(map((resp: ServiceRespone) => {
        return resp;
      }))
  }

  uploadDocument(tipoDoc: TipologiaDocumento, nomeDocumento: string, documentoVero: File, listaOrdiniPosFasi?: ListOrdinePosizioneFasiModel[], idNonConformitaList?: ListaNCModel[]): Observable<ServiceRespone> {
    let url = msConfig['ms-documenti'] + AppConstants.PATH_DOCUMENTI;
    console.log(url)
    let formData = new FormData();
    if (documentoVero.name.endsWith('.msg')) {
      formData.append('file', new Blob([(documentoVero)], {
        type: "application/vnd.ms-outlook"
      }));
    } else {
      formData.append('file', documentoVero);
    }

    let lista = [];
    let listaNC = [];
    if (listaOrdiniPosFasi && listaOrdiniPosFasi.length > 0 && listaOrdiniPosFasi[0]?.idOrdine !== null) {
      listaOrdiniPosFasi.forEach(element => {
        lista.push({
          idOrdine: element.idOrdine,
          idPosizioniList: element.posizioni ? element.posizioni : null,
          fasiStandardList: element.fasi ? element.fasi : null,
          codiciNcList: null
        })
      });

    } else {
      idNonConformitaList.forEach(element => {
        listaNC.push(element.codiceNC)
      });
      lista.push({
        idOrdine: null,
        idPosizioniList: null,
        fasiStandardList: null,
        codiciNcList: listaNC
      })

    }

    console.log('DOOOOOOOOC', lista)
    let params: any = {};
    params.tipoDoc = tipoDoc
    params.nomeDocumento = nomeDocumento

    formData.append('inputList', new Blob([JSON.stringify(lista)], {
      type: "application/json"
    }));

    return this.http
      .post(url, formData, { params })
      .pipe(map((resp: ServiceRespone) => {
        return resp;
      }))
  }

  getPreviewDocumento(idDocumento): Observable<any> {
    console.log('dentro preview');
    let url = msConfig['ms-documenti'] + AppConstants.PATH_DOWNLOAD_DOCUMENTO_AS_PREVIEW;
    const urlById = fmt.fmt(url, idDocumento);

    return this.http.get(urlById, { responseType: 'blob', observe: 'response' }).pipe(map((response) => {
      var filename = "";
      var disposition = response.headers.get('content-disposition');

      if (disposition && disposition.indexOf('inline') !== -1) {
        var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
        var matches = filenameRegex.exec(disposition);
        if (matches != null && matches[1]) {
          filename = matches[1].replace(/['"]/g, '');
        }
      }

      return {
        filename: filename,
        data: response
      };
    }));
  }

  downloadDocumentAsAttachment(idDocumento): Observable<any> {
    let url = msConfig['ms-documenti'] + AppConstants.PATH_DOWNLOAD_DOCUMENTO_AS_ATTACHMENT;
    const urlById = fmt.fmt(url, idDocumento);

    return this.http.get(urlById, { responseType: 'blob', observe: 'response' }).pipe(map((response) => {
      var filename = "";
      var disposition = response.headers.get('content-disposition');
      console.log(response);

      if (disposition && disposition.indexOf('attachment') !== -1) {
        var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
        var matches = filenameRegex.exec(disposition);
        if (matches != null && matches[1]) {
          filename = matches[1].replace(/['"]/g, '');
        }
      }

      return {
        filename: filename,
        data: response
      };
    }));
  }

  deleteDocument(idDocumento): Observable<ServiceRespone> {
    let url = msConfig['ms-documenti'] + AppConstants.PATH_DELETE_DOCUMENTO + idDocumento;

    return this.http
      .delete(url)
      .pipe(map((resp: ServiceRespone) => {
        let documento;
        documento = resp;
        return documento;
      }))
  }

  renameDocumentService(idDocumento, nuovoNome): Observable<ServiceRespone> {
    let params: any = {};
    params.nuovoNome = nuovoNome;
    params.idDocumento = idDocumento;
    let url = msConfig['ms-documenti'] + AppConstants.PATH_DOCUMENTI + '/' + idDocumento + AppConstants.PATH_RENAME_DOCUMENTO
    return this.http
      .post(url, null, { params })
      .pipe(map((resp: ServiceRespone) => {
        let isSuccess;
        isSuccess = resp;
        return isSuccess;
      }))
  }

  getQuantitaDaMatricole(idMateriale: number, excelMatricole: File): Observable<any> {
    let url = msConfig['ms-svincoli'] + AppConstants.PATH_GET_QUANTITA_MATRICOLE;
    let params: any = {};
    params.idMateriale = idMateriale;

    let formData = new FormData();
    formData.append('excelMatricole', excelMatricole);

    return this.http
      .post(url, formData, { params })
      .pipe(map((resp: ServiceRespone) => {
        let quantita;
        quantita = resp;
        return quantita;
      }))
  }

  createSvincoloAndUploadExcel(stato: StatoSvincolo, idPartita: number, idMateriale: number, idOrdine: number, idPosizione: number, quantita: number, isMatricola: boolean, excelMatricole: File): Observable<any> {
    console.log('dentro service create svincolo');
    let url = msConfig['ms-svincoli'] + AppConstants.PATH_CREATE_SVINCOLO;

    console.log(url)
    let formData = new FormData();
    formData.append('excelMatricole', excelMatricole);

    let params: any = {};

    params = CommonUtils.containsParam(params, stato, "stato")
    params = CommonUtils.containsParam(params, idPartita, "idPartita")
    params = CommonUtils.containsParam(params, idMateriale, "idMateriale")
    params = CommonUtils.containsParam(params, idOrdine, "idOrdine")
    params = CommonUtils.containsParam(params, idPosizione, "idPosizione")
    params = CommonUtils.containsParam(params, quantita, "quantita")
    params = CommonUtils.containsParam(params, isMatricola, "isMatricola")

    console.log(params);

    return this.http
      .post(url, formData, { params })
      .pipe(map((resp: ServiceRespone) => {
        return resp;
      }))
  }

}

